<template>
    <div class="row reports-occurrences-summary">
        <div class="col">
            <div class="row">
                <div class="col">
                    <table-resume
                        :title="title"
                        :route="route"
                        :externalFilters="filters"
                        :extraQueryParams="extraQueryParams"
                        :autoUpdateExternalFilter="autoUpdateExternalFilter"
                        :autoUpdateFilter="true"
                        :showTitleData="false"
                        titleClass="subtitle"
                        :settings="settings"
                        :columns="columns"
                        :loadingMsg="loadingMsg"
                        :notFoundMsg="notFoundMsg"
                        :orderByTemplate="orderByTemplate"
                        :confirmExportData="false"
                        :allowExportData="allowExportData"
                        :titleExportData="titleExportData"
                        :confirmMsgExportData="confirmMsgExportData"
                        :errorMsgExportData="errorMsgExportData"
                        tableWrapperClass="bg-lilac-light"
                        tableClass="table-responsive-sm"
                        :funcExportData="onExport"
                    >
                        <template v-slot:body="{row, index}">
                            <td v-for="column in columns" :class="column.class">
                                {{ columnValue(row, column) }}
                            </td>
                            <!-- <td>{{ row.code }}</td>
                            <td>{{ row.status ? row.status.name : '' }}</td>
                            <td v-if="row.family">{{ row.family ? row.family.name : '' }}</td>
                            <td v-if="row.kind">{{ row.kind ? row.kind.name : '' }}</td>
                            <td>{{ row.type ? row.type.name : '' }}</td>
                            <td>{{ row.unity ? row.unity.name : '' }}</td>
                            <td :class="columns[4].class">{{ row.created_at?moment(row.created_at).format('YYYY-MM-DD'):'' }}</td>
                            <td :class="columns[5].class">{{ row.updated_at?moment(row.updated_at).format('YYYY-MM-DD'):'' }}</td> -->
                            <!-- status_updated_at -->
                        </template>

                    </table-resume>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {HasLoadingState, HasReport} from './mixins/index';
    import { resolvePath, isFunction } from '@config/utils';

    export default {
        name: 'reportOccurrencesSummary',
        mixins: [
            HasLoadingState,
            HasReport
        ],
        components: {
            TableResume: () => import(/* webpackChunkName: "data-table" */ '@/app/shared/components/tables/DataTable'),
        },
        props: {
            autoUpdateExternalFilter: {
                type: Boolean,
                default: false
            },
            columns: {
                type: Array,
                default: () => {
                    return [
                        {
                            label: 'Referência',
                            field: 'code',
                            sortable: true,
                        },
                        {
                            label: 'Estado',
                            field: 'status_id',
                            field_label: 'status.name',
                            sortable: true,
                        },
                        {
                            label: 'Tipo',
                            field: 'type_id',
                            field_label: 'type.name',
                            sortable: true,
                        },
                        {
                            label: 'SubTipo',
                            field: 'subtype_id',
                            field_label: 'subtype.name',
                            sortable: true,
                        },
                        {
                            label: 'Departamento',
                            field: 'unity_id',
                            field_label: 'unity.name',
                            sortable: true,
                        },
                        {
                            label: 'Criação',
                            field: 'created_at',
                            sortable: true,
                            class: 'd-none d-lg-table-cell',
                            func: (val) => moment(val).format('YYYY-MM-DD'),
                        },
                        {
                            label: 'Alteração',
                            field: 'status_updated_at',
                            sortable: true,
                            class: 'd-none d-lg-table-cell',
                            func: (val) => moment(val).format('YYYY-MM-DD'),
                        },
                    ];
                },
            }
        },
        data() {
            return {
                settings: {
                    order_by: 'created_at',
                    sort: 'desc',
                },
            }
        },
        mounted() {

        },
        methods: {
            columnValue(obj, column) {
                let val = resolvePath(obj, column.field_label || column.field);
                return isFunction(column.func) ? column.func(val) : val;
            },
        }
    }
</script>

<style lang="scss" scoped>
    // .reports-occurrences-summary {
    //     td {
    //         white-space: break-spaces;
    //     }
    // }
</style>